export const LOCATION_TYPE = {
  DEFAULT: 'DEFAULT',
  GPS: 'GPS',
  MANUAL: 'MANUAL',
};

export type LocationType = keyof typeof LOCATION_TYPE;

export interface LocationData {
  latitude: string;
  longitude: string;
  locationType: LocationType;
  locationTime: number;
  hasPermissionError: boolean;
  addressOnlyRoad?: string;
  address?: string;
  addressShort?: string;
}
